import React from 'react';
import { Pill } from '../NotionUI';
import { optionColor } from '../ProjectCell';
import taskValues from './TaskValues';
import { useLanguage } from '../../i18n/LanguageContext';
import { flattenTree, groupKeyToValue } from '../../utils/projectView';

const MAX_VALUES = 6;

/**
 * Vista lista: una riga compatta per attività (titolo e pochi valori), con la
 * casella "fatto" se c'è una colonna di stato con un'opzione completata,
 * raggruppamento e sotto-attività rientrate.
 */
function ProjectList({ tasks, allTasks, columns, users, groups, groupColumn, treeMode, statusColumn, onOpen, onPatchTask, onAdd }) {
  const { t } = useLanguage();

  const doneValues = statusColumn ? statusColumn.options.filter((o) => o.done).map((o) => o.value) : [];
  const openValue = statusColumn ? (statusColumn.options.find((o) => !o.done)?.value ?? null) : null;
  const canToggle = doneValues.length > 0;
  const isDone = (task) => canToggle && doneValues.includes(task.data[String(statusColumn.id)]);

  const toggleDone = (task, checked) => onPatchTask(task.id, { data: { [String(statusColumn.id)]: checked ? doneValues[0] : openValue } });

  const rowsOf = (list) => (treeMode ? flattenTree(list) : list.map((task) => ({ task, depth: 0 })));
  const valueColumns = columns.filter((c) => c.type !== 'title' && (!groupColumn || c.id !== groupColumn.id));

  const renderRow = ({ task, depth }) => (
    <div key={task.id} className="pl-row" style={{ paddingLeft: 8 + depth * 22 }}>
      {canToggle && (
        <input type="checkbox" className="pl-check" checked={isDone(task)} aria-label={t('projectDetail.markDone')} onChange={(e) => toggleDone(task, e.target.checked)} />
      )}
      <button type="button" className={'pl-title' + (isDone(task) ? ' pl-title-done' : '')} onClick={() => onOpen(task)}>
        {task.title || t('projectDetail.untitled')}
      </button>
      <span className="pl-values">{taskValues(task, valueColumns, { users, allTasks, max: MAX_VALUES })}</span>
    </div>
  );

  return (
    <div className="pl-list">
      {groups ? groups.map((group) => (
        <div key={group.key || 'none'} className="pl-group">
          <div className="pl-group-head">
            {group.option ? <Pill dot color={optionColor(group.option)}>{group.label}</Pill> : <span className="nt-muted">{group.label || t('projectView.noValue')}</span>}
            <span className="nt-muted">{group.tasks.length}</span>
            <button type="button" className="pd-row-delete" style={{ opacity: 1 }} aria-label={t('projectDetail.newTask')} onClick={() => onAdd(groupKeyToValue(groupColumn, group.key))}>+</button>
          </div>
          {rowsOf(group.tasks).map(renderRow)}
        </div>
      )) : rowsOf(tasks).map(renderRow)}
      {tasks.length === 0 && <p className="nt-empty">{t('projectDetail.noTasks')}</p>}
      <button type="button" className="nt-add-row" onClick={() => onAdd(null)}>
        <span aria-hidden="true">+</span> {t('projectDetail.newTask')}
      </button>
    </div>
  );
}

export default ProjectList;
